import type {BioIconProps} from './common-types'

export function IconSuccess({...attributes}: BioIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.0001 16.4104L17.7072 9.70328L16.293 8.28906L11.0001 13.582L7.70718 10.2891L6.29297 11.7033L11.0001 16.4104Z"
        fill="#78C02A"
      />
    </svg>
  )
}
